import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, Pagination, Typography } from '@mui/material';
import { LimitContentStyled, PaginationContainerStyled, SelectStyled } from './table.styled';
var LIST_LIMITS = [10, 20, 50, 100];
var BasePagination = function (props) {
    var _a = props.page, page = _a === void 0 ? 1 : _a, _b = props.limit, limit = _b === void 0 ? 10 : _b, _c = props.totalPage, totalPage = _c === void 0 ? 1 : _c, handleChangePagination = props.handleChangePagination;
    var handleChangePage = function (_, page) {
        handleChangePagination && handleChangePagination(page, limit);
    };
    var handleChangeLimit = function (event) {
        handleChangePagination && handleChangePagination(page, Number(event.target.value));
    };
    return (_jsxs(PaginationContainerStyled, { children: [_jsxs(LimitContentStyled, { children: [_jsx(Typography, { children: "S\u1ED1 d\u00F2ng hi\u1EC3n th\u1ECB" }), _jsx(SelectStyled, { defaultValue: limit, variant: 'outlined', onChange: handleChangeLimit, children: LIST_LIMITS.map(function (limit, index) { return (_jsx(MenuItem, { value: limit, children: limit }, index)); }) })] }), _jsx(Pagination, { page: page, count: totalPage, shape: 'rounded', onChange: handleChangePage })] }));
};
export default BasePagination;
